// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__EF89H","NavbarTitle":"Navbar_NavbarTitle__HUu+X"};